import * as PopoverPrimitive from '@radix-ui/react-popover'
import { ComponentProps, PropsWithChildren } from 'react'

import { cn } from '@/shared/lib'

type ContentProps = ComponentProps<typeof PopoverPrimitive.Content>

export const Popup = ({
  side = 'bottom',
  sideOffset = 0,
  align = 'center',
  alignOffset = 0,
  className,
  children,
  ...props
}: PropsWithChildren<ContentProps>) => {
  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        className={cn(
          'z-popover bg-white text-balance outline-hidden',
          'shadow-[0px_0px_7px_0px_rgba(0,0,0,0.25)]',
          'data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95',
          'data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95',
          'data-[side=bottom]:slide-in-from-top-2',
          'data-[side=left]:slide-in-from-right-2',
          'data-[side=right]:slide-in-from-left-2',
          'data-[side=top]:slide-in-from-bottom-2',
          className,
        )}
        side={side}
        sideOffset={sideOffset}
        align={align}
        alignOffset={alignOffset}
        {...props}
      >
        {children}
      </PopoverPrimitive.Content>
    </PopoverPrimitive.Portal>
  )
}
